
import { supabase } from '@/integrations/supabase/client';
import { Store } from '@/types';
import { toast } from 'sonner';

/**
 * Busca todas as lojas
 */
export const fetchStores = async (): Promise<Store[]> => {
  try {
    const { data, error } = await supabase
      .from('stores')
      .select('*')
      .order('name');
      
    if (error) throw error;
    
    return data || [];
  } catch (error) {
    console.error('Erro ao buscar lojas:', error);
    toast.error('Não foi possível carregar as lojas');
    return [];
  }
};

/**
 * Busca uma loja pelo ID
 */
export const fetchStoreById = async (id: string): Promise<Store | null> => {
  try {
    const { data, error } = await supabase
      .from('stores')
      .select('*')
      .eq('id', id)
      .single();
      
    if (error) throw error;
    
    return data;
  } catch (error) {
    console.error('Erro ao buscar loja:', error);
    toast.error('Não foi possível carregar os dados da loja');
    return null;
  }
};

/**
 * Cria uma nova loja
 */
export const createStore = async (storeData: { name: string, location?: string }): Promise<Store | null> => {
  try {
    const { data, error } = await supabase
      .from('stores')
      .insert(storeData)
      .select()
      .single();
      
    if (error) throw error;
    
    toast.success('Loja criada com sucesso!');
    return data;
  } catch (error) {
    console.error('Erro ao criar loja:', error);
    toast.error('Não foi possível criar a loja');
    return null;
  }
};

/**
 * Atualiza uma loja existente
 */
export const updateStore = async (id: string, storeData: { name?: string, location?: string }): Promise<Store | null> => {
  try {
    const { data, error } = await supabase
      .from('stores')
      .update(storeData)
      .eq('id', id)
      .select()
      .single();
      
    if (error) throw error;
    
    toast.success('Loja atualizada com sucesso!');
    return data;
  } catch (error) {
    console.error('Erro ao atualizar loja:', error);
    toast.error('Não foi possível atualizar a loja');
    return null;
  }
};

/**
 * Exclui uma loja
 */
export const deleteStore = async (id: string): Promise<boolean> => {
  try {
    const { error } = await supabase
      .from('stores')
      .delete()
      .eq('id', id);
      
    if (error) throw error;
    
    toast.success('Loja excluída com sucesso!');
    return true;
  } catch (error) {
    console.error('Erro ao excluir loja:', error);
    toast.error('Não foi possível excluir a loja');
    return false;
  }
};

/**
 * Busca todas as lojas do banco de dados
 * Alias para fetchStores para manter compatibilidade
 */
export const getStoresFromDatabase = async (): Promise<Store[]> => {
  return fetchStores();
};

/**
 * Busca uma loja pelo ID
 * Alias para fetchStoreById para manter compatibilidade
 */
export const getStoreById = async (id: string): Promise<Store | null> => {
  return fetchStoreById(id);
};
